// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MFrX","option":"styles_option__1u_BE","selected":"styles_selected__36PR6"};